export default "__VITE_ASSET__5C$GIRxU__"